export enum ExpenseStatusEnum {
  SCHEDULED = "SCHEDULED", // XISJUSTE - Alterar Alterar para MANUALLY_SCHEDULED
  AUTOMATICALLY_SCHEDULED = "AUTOMATICALLY_SCHEDULED",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  REVIEW = "REVIEW",
  PENDING = "PENDING",
  PAID = "PAID"
}

export const ExpenseStatusLabel = new Map<ExpenseStatusEnum, string>([
  [ExpenseStatusEnum.SCHEDULED, "Agendamento manual"],
  [ExpenseStatusEnum.AUTOMATICALLY_SCHEDULED, "Agendamento automático"],
  [ExpenseStatusEnum.REJECTED, "Rejeitado"],
  [ExpenseStatusEnum.APPROVED, "Aprovado"],
  [ExpenseStatusEnum.REVIEW, "Em revisão"],
  [ExpenseStatusEnum.PENDING, "Pendente"],
  [ExpenseStatusEnum.PAID, "Pago"]
]);



// WEBPACK FOOTER //
// ./src/services/Enum/ExpenseStatusEnum.ts